import { render, staticRenderFns } from "./InstrumentoModal.vue?vue&type=template&id=2a0a820e&scoped=true"
import script from "./InstrumentoModal.vue?vue&type=script&lang=js"
export * from "./InstrumentoModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a0a820e",
  null
  
)

export default component.exports